import { gql } from "@apollo/client"

const GET_PREVIEW_INVITATION_EMAIL = gql`
  query($input: PreviewInvitationEmailInput!) {
    previewInvitationEmail(input: $input) {
      html
      text
    }
  }
`

export { GET_PREVIEW_INVITATION_EMAIL }
